import { jwtDecode } from "jwt-decode";

export const setAuthDetails = (access_token, refresh_token) => {
  const decoded = jwtDecode(access_token);
  const givenDate = new Date(decoded.exp * 1000);

  localStorage.setItem('access_token', access_token);
  localStorage.setItem('refresh_token', refresh_token);
  localStorage.setItem('token_expiry_date', givenDate);
};

export const removeAuthDetails = () => {
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
  localStorage.removeItem('token_expiry_date');
  localStorage.removeItem('persist:root');
};
